export default {
  "title": "Dais Documentation",
  "tagline": "Dais Documentation",
  "url": "https://www.dais.com",
  "baseUrl": "/",
  "onBrokenLinks": "warn",
  "onBrokenMarkdownLinks": "warn",
  "favicon": "/favicon.ico",
  "organizationName": "Internet of Insurance",
  "projectName": "Internet of Insurance",
  "themeConfig": {
    "prism": {
      "theme": {
        "plain": {
          "color": "#bfc7d5",
          "backgroundColor": "#292d3e"
        },
        "styles": [
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(105, 112, 152)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "inserted"
            ],
            "style": {
              "color": "rgb(195, 232, 141)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation",
              "selector"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(191, 199, 213)"
            }
          },
          {
            "types": [
              "class-name",
              "attr-name"
            ],
            "style": {
              "color": "rgb(255, 203, 107)"
            }
          },
          {
            "types": [
              "tag",
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 114)"
            }
          },
          {
            "types": [
              "operator"
            ],
            "style": {
              "color": "rgb(137, 221, 255)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "rgb(221, 221, 221)"
            }
          }
        ]
      },
      "additionalLanguages": []
    },
    "hideableSidebar": false,
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false,
      "switchConfig": {
        "darkIcon": "🌜",
        "lightIcon": "🌞",
        "darkIconStyle": {
          "marginLeft": "2px"
        },
        "lightIconStyle": {
          "marginLeft": "1px"
        }
      }
    },
    "navbar": {
      "style": "primary",
      "title": "Dais Documentation",
      "logo": {
        "alt": "Internet of Insurance",
        "src": "img/branding/ioi-white-icon.svg",
        "href": "docs/start"
      },
      "hideOnScroll": false,
      "items": []
    },
    "footer": {
      "style": "light",
      "copyright": "Copyright © 2023 Dais, Inc.",
      "links": []
    },
    "docs": {
      "versionPersistence": "localStorage"
    },
    "metadatas": []
  },
  "plugins": [
    [
      "/app/node_modules/@cmfcmf/docusaurus-search-local/src/index.js",
      {}
    ],
    "/app/web-pack-plugin"
  ],
  "presets": [
    [
      "@docusaurus/preset-classic",
      {
        "routeBasePath": "/",
        "slug": "/",
        "docs": {
          "sidebarPath": "/app/sidebars.js"
        },
        "theme": {
          "customCss": "/app/src/css/ioi-default.css"
        }
      }
    ]
  ],
  "baseUrlIssueBanner": true,
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "onDuplicateRoutes": "warn",
  "customFields": {},
  "themes": [],
  "titleDelimiter": "|",
  "noIndex": false
};